import React, { Component } from 'react';
import { Grid, Header, Icon, Input} from 'semantic-ui-react';
import HelpCard from './Components/helpCard';
import HelpTile from './Components/helpTile';
import ModalImprovement from './Components/modalImprovement';
import Changelog from '../Version/changelog.json';
import {Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import { withTranslation } from 'react-i18next';

class Help extends Component {
    constructor(props) {
		super(props);

		this.state = {
            search:"",
            visible: true,
            openProblem: false,
            openImprovement: false,
            redirectIssue: false,
            versionToNav: null
		};
	}

    search = (obj) => {
       var find =[]
       obj.releases.forEach(object => {
        const version = Object.values(object)[0];
        if (version.deprecated.find(item => item.toLowerCase().includes(this.state.search.toLowerCase()))){
            find.push(version)
        } else if (version.improved.find(item => item.toLowerCase().includes(this.state.search.toLowerCase()))){
            find.push(version)
        } else if (version.bug.find(item => item.toLowerCase().includes(this.state.search.toLowerCase()))){
            find.push(version)
        } else if (version.new.find(item => item.toLowerCase().includes(this.state.search.toLowerCase()))){
            find.push(version)
        } else if (version.removed.find(item => item.toLowerCase().includes(this.state.search.toLowerCase()))){
            find.push(version)
        }
       })

    return find.length > 0 ?find.map(version => <HelpTile
                                icon="fork"
                                key={version.version}
                                description={version.date}
                                onTap={() => {this.setState({redirectIssue: true, versionToNav: version.version})}}
                                title={version.version} />
    ) :       <Header icon>
    <Icon name='undo alternate' style={styles.noSearchItem}  size="huge"/>
    <div style={styles.titleNoSearchItem}>Oopss... Aucun résultat trouvé essayé de rechercher autre choses</div>
  </Header>
    }


    render(){
        if (this.state.redirectIssue){
            return <Redirect to={{
                pathname: "/home/versions",
                state: { versionToNav: this.state.versionToNav }
              }}/>
        }
        return(
           <Grid style={{marginBottom: '3vh'}} textAlign='center' verticalAlign='middle'>
            <Grid.Column  style={styles.header} >
           <div style={styles.text}>Besoin d'aide ?</div>
                <Input
                    onChange={(e) => this.setState({search: e.target.value})}
                    style={styles.inputContainer}
                    placeholder='Dites nous comment peut on vous aidez...'>
                    <input style={styles.input} />
                </Input>
                    </Grid.Column>
                  {this.state.search.length > 3 ? this.search(Changelog): <Grid>
                   <Grid.Row columns={3} centered>
                        <HelpCard
                        icon="book"
                        href="https://google.com/"
                        title="Manuel"/>
                        <HelpCard
                        icon="fork"
                        title="Version" 
                        onTap={() => this.setState({redirectIssue: true})}
                        />
                        <HelpCard 
                        icon="lab"
                        href="https://google.com/"
                        title="Catalogue" />
                    </Grid.Row>
                    <Grid.Row columns={3} centered>
                        <HelpCard 
                            icon="lightbulb"
                            title="Improvement"
                            onTap={() => this.setState({openImprovement: true})}
                            />
                        <HelpCard
                            icon="warning sign"
                            title="Probleme" 
                            onTap={() => this.setState({openProblem: true})}
                        />
                    </Grid.Row>
                    <ModalImprovement
                        selectLabel="Feature qui rencontre un probleme"     
                        selectPlaceHolder="Feature affecté"     
                        textAreaLabel="Nature du probleme"     
                      onClose={() => this.setState({openProblem:false})} 
                      open={this.state.openProblem}
                      />
                    <ModalImprovement
                        selectLabel="Feature à ameliorer"     
                        selectPlaceHolder=""     
                        textAreaLabel="Àmelioration à proposer"   
                        onClose={() => this.setState({openImprovement:false})} 
                        open={this.state.openImprovement}/>
                    </Grid>
                    }
                </Grid>
        );
    }
}

const styles = {

    header: {
        maxWidth: '100vw',
        height: '37vh',
        backgroundImage:"linear-gradient(178deg, #6CADDF 0%, #59C4B0 100%)",
        padding: 40,
        boxShadow:"0px 9px 49px #00000043",
        minWidth: "100vw",
        marginBottom: '5vh'
    },
    inputContainer: {
        minWidth:"40vw",
        maxWidth: "40vw",
    },
    titleNoSearchItem: {
        
    },
    input: {

        minHeight: "6.5vh",
        borderRadius: "38px",
        boxShadow:" 0px 7px 20px #00000029",
    },
    text: {
        // textAlign: "center",
        marginTop: '2vh',
        marginBottom: '3vh',
        color:"#FFFFFF",
        font: "oblique normal bold 40px/60px Helvetica"
    },
    noSearchItem:{
        color: "#6CADDF"
    }
}
const mapStateToProps = (state) => {
	return {
		user: state.user,
    }
}
const mapDispatchToProps = {

};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Help));